/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-10-20
 * @brief EHP WorkOrder - 점검 출동 개발
 *
 ********************************************************************/
import React, { useState } from "react";
import WorkInspectioList from "./WorkInspectioList";
/**
 * @brief EHP WorkOrder - 점검 출동 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
//component
function WorkInspectionMain(props) {
    //props
    const setPopWin = props.setPopWin;
    const setNodata = props.setNodata;
    const [adminType, setAdminType] = useState("AUTH"); // AUTH, LANG
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH, SET
    const [workMode, setWorkMode] = useState("READ");
    return (React.createElement(React.Fragment, null,
        React.createElement(WorkInspectioList, { nodata: props.nodata, setPopWin: setPopWin, setNodata: setNodata })));
}
export default WorkInspectionMain;
